import script from "./MediaPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaPicker.vue?vue&type=script&setup=true&lang=js"

import "./MediaPicker.vue?vue&type=style&index=0&id=005e1686&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-005e1686"]])

export default __exports__